module.exports = __webpack_public_path__ + "img/sport_bg3.e6821d78.png";